import React from "react";
import { useSelector } from "react-redux";
import { Download, ExternalLink } from "lucide-react";
import { Button } from "../../../../empreenderUI/ui/Button";
import { translations } from "../../../../utils/language";

const BoxPageCheckout = () => {
	const language = useSelector((state) => state.reducerLanguage);

	const userToken = (() => {
		try {
			return JSON.parse(localStorage.getItem("depoimentos@login")).integration.user_token;
		} catch {
			return "";
		}
	})();

	const getCodePLataform = () => {
		try {
			const platform = JSON.parse(localStorage.getItem("depoimentos@login")).integration?.platform;
			switch (platform) {
				case "nuvemshop":
					return "1";
				case "shopify":
					return "4";
				case "yampi":
					return "2";
				default:
					return "1";
			}
		} catch {
			return "1";
		}
	};

	const link = `https://meuarquivodigital.com/suamidialink/${userToken}/${getCodePLataform()}`;

	return (
		<div className="mx-auto w-full max-w-2xl px-4 py-6 md:px-6">
			<div className="mb-6">
				<h1 className="text-xl font-semibold tracking-tight text-slate-900">
					{translations["thema-link-downloads"]?.[language.data]}
				</h1>
				<p className="mt-1 text-sm text-gray-500">
					{translations["thema-link-downloads-desc"]?.[language.data]}
				</p>
			</div>

			<div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
				<div className="flex items-start gap-3 border-b border-gray-200 bg-gray-50 px-4 py-3.5">
					<div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700">
						<Download size={16} />
					</div>
					<div className="min-w-0">
						<p className="text-sm font-semibold text-slate-800">
							{translations["thema-link-downloads"]?.[language.data]}
						</p>
						<p className="text-xs text-gray-500">
							{translations["thema-link-downloads-instrucao"]?.[language.data]}
						</p>
					</div>
				</div>

				<div className="flex flex-col gap-4 px-4 py-4">
					<div className="overflow-hidden rounded-lg border border-gray-200 bg-black">
						<div className="relative aspect-video w-full">
							<iframe
								className="absolute inset-0 h-full w-full"
								src="https://www.youtube.com/embed/EDYWamyVTug"
								title="YouTube video player"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
								referrerPolicy="strict-origin-when-cross-origin"
							/>
						</div>
					</div>

					<div className="flex flex-col gap-1.5">
						<label className="text-sm font-semibold text-slate-800">
							{translations["thema-link"]?.[language.data] || "Link"}
						</label>
						<div className="flex flex-col gap-2 sm:flex-row sm:items-stretch">
							<button
								type="button"
								onClick={() => window.open(link, "_blank")}
								className="flex h-9 min-w-0 flex-1 items-center truncate rounded-md border border-gray-200 bg-white px-3 text-left font-mono text-xs text-gray-700 transition-colors hover:border-gray-300 hover:bg-gray-50"
								title={link}
							>
								{link}
							</button>
							<Button
								type="button"
								variant="outline"
								className="h-9 shrink-0 gap-2 !py-0"
								onClick={() => window.open(link, "_blank")}
							>
								<ExternalLink size={16} />
								{translations["common-open"][language.data]}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BoxPageCheckout;
